import { render } from "./IVkDoc.vue?vue&type=template&id=502b2f86"
import script from "./IVkDoc.vue?vue&type=script&lang=js"
export * from "./IVkDoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__